import React from "react";
import SpecificButton from "../specificButton/SpecificButton";
import HomeModal from "../../assets/images/home-modal.webp";

function StoreHomeCard({ handleClick }) {

    return (
        <div className="h-full md:max-w-[460px] mx-auto pt-2 w-full items-center flex flex-col justify-end text-center">
            <img src={HomeModal} alt="home" className="max-h-[100vh] w-auto" />
            <div className="w-full max-h-[60%] md:max-w-[460px] flex flex-col justify-end text-center fixed bottom-0 py-12 px-4 bg-gradient-to-t from-[#000] to-transparent h-full">
                <h1 className="italic text-white mb-2">Swan</h1>
                <h2 className="text-white mb-4 text-[24px]">YOU FOR ONLINE SHOPPING</h2>
                <div className="max-w-[180px] mx-auto w-full">
                    <SpecificButton buttonFunc={handleClick} className="w-full" buttonText="Sign Up" altroute="" alttxt="" />
                </div>
            </div>
        </div>
        
    );
}

export default StoreHomeCard;
